import { render, staticRenderFns } from "./Backgrounds.vue?vue&type=template&id=4a7636fe&scoped=true"
import script from "./Backgrounds.vue?vue&type=script&lang=js"
export * from "./Backgrounds.vue?vue&type=script&lang=js"
import style0 from "./Backgrounds.vue?vue&type=style&index=0&id=4a7636fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7636fe",
  null
  
)

export default component.exports